import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

const BlogHeader = styled.header`
  margin-bottom: ${themeGet('space.l')};
  max-width: 46.875rem;

  @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: ${themeGet('space.xl')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.xl')}) {
    max-width: 62.5rem;
    margin-left: -${themeGet('space.xxl')};
    margin-right: -${themeGet('space.xxl')};
  }
`

const BlogHeaderTitle = styled.h1`
  font-size: ${themeGet('fontSizes.h2')};
  line-height: 1;

  @media screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: ${themeGet('fontSizes.h1')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: ${themeGet('fontSizes.title')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.xl')}) {
    max-width: 62.5rem;
  }
`

const BlogHeaderTextLabel = styled.b`
  @media screen and (min-width: ${themeGet('breakpoints.sm')}) {
    border-top: 1px solid ${themeGet('colors.border')};
    padding-top: ${themeGet('space.s')};
  }
`

BlogHeader.Title = BlogHeaderTitle
BlogHeader.TextLabel = BlogHeaderTextLabel

export default BlogHeader
